// The console's calls for a tenant's agents and their model profiles (spec 15
// §4 S23 and §5; D-645), through the one generated client like the rest of
// platform-api.ts. The switch carries the caller's held Idempotency-Key.

import type { components } from "@assessly/api-client";
import { client } from "../../../lib/api";
import { idempotent, unwrap } from "./platform-api";

export type TenantAgents = components["schemas"]["PlatformTenantAgentsResponse"];
export type TenantAgent = components["schemas"]["PlatformTenantAgent"];
export type AgentModelProfile = components["schemas"]["PlatformAgentModelProfile"];
export type AgentModelDeployment = components["schemas"]["PlatformAgentModelDeployment"];

export async function getTenantAgents(id: string, signal?: AbortSignal): Promise<TenantAgents> {
  const result = await client.GET("/v1/platform/tenants/{id}/agents", {
    params: { path: { id } },
    ...(signal ? { signal } : {}),
  });
  return unwrap(result, "could not load the tenant's agents");
}

export async function setAgentModelProfile(
  tenantId: string,
  agentId: string,
  body: { model_profile: string; version: number },
  key: string,
): Promise<TenantAgent> {
  const result = await client.PUT("/v1/platform/tenants/{id}/agents/{agentId}/model-profile", {
    params: { path: { id: tenantId, agentId } },
    body,
    headers: idempotent(key),
  });
  return unwrap(result, "could not switch the agent's model profile");
}
